export default function PHP_floatval() {
  return (
    <div>
      <h1>PHP_floatval</h1>
    </div>
  );
}
